'use client';

import { useTranslations } from 'next-intl';
import { CheckOverCircle } from 'assets/icons/CheckOverCircle';
import { ImageContainer, InfoModalContainer } from './layout';
import { CustomImage } from 'components/shared/custom-image';
import { useWindowSize } from 'hooks/dom/useWindowSize';
import { getCompressedAssetUrl } from 'lib/config/assetUrls';
import styles from './VitaminAngels.module.css';

const VA_LOGOMARK = getCompressedAssetUrl(
  '/web_v2/site-static/vitamin-angels/va-logomark.png',
);

export const VitaminAngelsInfoModal = () => {
  const t = useTranslations('ring');
  const { width } = useWindowSize();
  return (
    <InfoModalContainer>
      <div className={styles.vitaminAngelsWrapper}>
        <h2 className={styles.title}>
          {t('ring.infoModals.vitaminAngels.title')}
        </h2>

        <ImageContainer
          style={{ borderRadius: 16, overflow: 'hidden', marginBottom: 24 }}
        >
          <CustomImage
            src={`web_v2/cart-info-modals/vitamin-angels${
              width > 1024 ? '-desktop' : '-mobile'
            }.png`}
            width={1388}
            height={1133}
            alt={t('ring.infoModals.vitaminAngels.imageAlt')}
            priority
          />
          {/* <div className="overlay">
            <img
              className="va-logo-overlay"
              src="/va-logomark.png"
              alt="Vitamin Angels"
            />
            <div className="divider" />
            <UHLogoWhite style={{ width: 28, height: 'auto' }} />
          </div> */}
        </ImageContainer>

        <div className={styles.bodyText}>
          <p>{t('ring.infoModals.vitaminAngels.body.p1')}</p>
          <p>{t('ring.infoModals.vitaminAngels.body.p2')}</p>
        </div>

        <div className={styles.partnershipCallout}>
          <img src={VA_LOGOMARK} alt="Vitamin Angels" />
          <p>{t('ring.infoModals.vitaminAngels.partnership')}</p>
        </div>

        <h3 className={styles.sectionTitle}>
          {t('ring.infoModals.vitaminAngels.sectionTitle')}
        </h3>

        <div className={styles.checkItems}>
          <div className={styles.checkItem}>
            <CheckOverCircle />
            <p>
              {t.rich('ring.infoModals.vitaminAngels.checks.a', {
                strong1: (chunks) => <strong>{chunks}</strong>,
                strong2: (chunks) => <strong>{chunks}</strong>,
              })}
            </p>
          </div>
          <div className={styles.checkItem}>
            <CheckOverCircle />
            <p>
              {t.rich('ring.infoModals.vitaminAngels.checks.b', {
                strong1: (chunks) => <strong>{chunks}</strong>,
              })}
            </p>
          </div>
          <div className={styles.checkItem}>
            <CheckOverCircle />
            <p>
              {t.rich('ring.infoModals.vitaminAngels.checks.c', {
                strong1: (chunks) => <strong>{chunks}</strong>,
              })}
            </p>
          </div>
        </div>
      </div>
    </InfoModalContainer>
  );
};
